module.exports = __webpack_public_path__ + "static/media/arrow-right.b55a2b98.svg";